export const AnchorLinkWrapper =
  'flex flex-row items-center justify-center left-[12px] bottom-0 px-4 py-2 fixed z-[999] bg-white border-black mb-4 md:mb-0 border md:border-b-0 rounded-md md:rounded-b-none md:rounded-t-md text-10 shadow-xl uppercase tracking-0 cursor-pointer'

export const AnchorLinkText = 'pl-2 leading-24'
